import React from 'react';
import { Flex, Icon, Spinner, Text } from '@chakra-ui/react';
import { Check } from 'react-feather';

export const SavedIndicator = ({ isLoading, isSaved }) => {
  if (isLoading) {
    return (
      <Flex align="center">
        <Spinner colorScheme="blackAlpha" size="xs" />
        <Text textStyle="label" ml={1}>
          Saving...
        </Text>
      </Flex>
    );
  }
  if (isSaved) {
    return (
      <Flex align="center">
        <Icon as={Check} />
        <Text textStyle="label" ml={1} role="alert" aria-live="assertive">
          Saved
        </Text>
      </Flex>
    );
  }
  return null;
};
